import styled, { keyframes } from 'styled-components';

const ErrorAnimation = keyframes`  
  0% { 
    border-color: rgba(2228, 8, 8, 1);
    background: rgba(0, 0, 0, 0.9);
  }

  50% {
    border-color: rgba(2228, 8, 8, 0.4);
    background: rgba(0, 0, 0, 0.8);
  }

  100% { 
    border-color: rgba(2228, 8, 8, 1);
    background: rgba(0, 0, 0, 0.9);
  }
`;

export const Container = styled.div`
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  z-index: 10000;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
  height: 100%;

  border: 5px solid rgba(2228, 8, 8, 0.5);

  animation-name: ${ErrorAnimation};
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: normal;

  @media (max-width: 1024px) {
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 800px;
  border-radius: 10px;
  padding: 10px;

  main {
    float: left;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    i {
      margin: 0 5px 0 0;
    }

    div {
      float: left;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      h1 {
        font-size: 40px;
        color: #fff;
      }

      h2 {
        font-size: 30px;
        color: rgba(233, 24, 24, 1) !important;
      }

      small {
        color: #999;
        font-size: 16px;
      }

      button {
        background: none;
        padding: 10px;
        cursor: pointer;
        outline: none;
        transition: all 0.5s ease;

        &:hover {
          opacity: 0.5;
        }
        
      }
    }
  }

  @media (max-width: 1024px) {
  }
`;
